<template>
  <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                         :titleLabel="$t(this.titleLabel)"
                         :parentScreen="parentScreen">
    <div class="form-group row">
      <div class="col-md-6 offset-md-3">
        <div class="checkbox">
          <div class="form-check">
            <input class="form-check-input" type="checkbox"
                   id="cryptoPurposeFluctuationFlg"
                   v-model="$v.input['amsCustomerDetail.cryptInvestmentPurposeView'].cryptoPurposeFluctuationFlg.$model"
                   true-value="1"
                   false-value="0"
                   @change="handleForceNewEvent"
            >
            <label class="form-check-label" for="cryptoPurposeFluctuationFlg">
              {{ $t('profile.bo_investment_purpose.crypto_purpose_fluctuation_flg') }}
            </label>
          </div>
        </div>
        <div class="checkbox">
          <div class="form-check">
            <input
                class="form-check-input"
                type="checkbox"
                id="cryptoPurposeDiverseFlg"
                v-model="$v.input['amsCustomerDetail.cryptInvestmentPurposeView'].cryptoPurposeDiverseFlg.$model"
                true-value="1"
                false-value="0"
                @change="handleForceNewEvent"
            >
            <label class="form-check-label" for="cryptoPurposeDiverseFlg">
              {{ $t(this.cryptoPurposeDiverseFlag) }}
            </label>
          </div>
        </div>
        <div class="checkbox">
          <div class="form-check">
            <input
                class="form-check-input"
                type="checkbox"
                id="cryptoPurposeAssetFlg"
                v-model="$v.input['amsCustomerDetail.cryptInvestmentPurposeView'].cryptoPurposeAssetFlg.$model"
                true-value="1"
                false-value="0"
                @change="handleForceNewEvent"
            >
            <label class="form-check-label" for="cryptoPurposeAssetFlg">
              {{ $t('profile.bo_investment_purpose.crypto_purpose_asset_flg') }}
            </label>
          </div>
        </div>
        <div class="error-messages ng-active"
             v-if="$v.input['amsCustomerDetail.cryptInvestmentPurposeView'].$error || $v.input['amsCustomerDetail.cryptInvestmentPurposeView'].$anyError">
          <div class="form-check">
            {{ $t('MSG_TRS_NAF_0004_param', {param1: $t(this.errorMsgParam)}) }}
          </div>
        </div>
      </div>
    </div>
    <template v-if="this.isParentScreenEditProfile">
      <div class="form-action">
        <button class="btn btn-sm btn-submit btn-success mr-2"
                :disabled="isDisabledButtonSubmit"
                :type="this.getButtonType()">
          {{ $t('profile.button.submit') }}
        </button>
        <button class="btn btn-default btn-cancel btn-sm"
                type="button"
                @click="reverseInput">
          {{ $t('profile.button.cancel') }}
        </button>
      </div>
    </template>
  </ForceNewsBlockWrapper>
</template>
<script>
/**
 * @author HungNS
 */
import formMixin from '@/common/mixins/form';
import forceNewUtil from "@/common/mixins/forceNewUtil";
import {parentCheckboxRequiredValidation} from '@/common/helpers/validation'

export default {
  name: "UpdateCryptoInvestPurpose",
  props: {},
  data() {
    return {}
  },
  mixins: [formMixin, forceNewUtil],
  methods: {

  },
  validations() {
    return {
      input: {
        'amsCustomerDetail.cryptInvestmentPurposeView': {
          cryptoPurposeFluctuationFlg: {
            validCheckbox: parentCheckboxRequiredValidation(this.input['amsCustomerDetail.cryptInvestmentPurposeView'])
          },
          cryptoPurposeDiverseFlg: {
            validCheckbox: parentCheckboxRequiredValidation(this.input['amsCustomerDetail.cryptInvestmentPurposeView'])
          },
          cryptoPurposeAssetFlg: {
            validCheckbox: parentCheckboxRequiredValidation(this.input['amsCustomerDetail.cryptInvestmentPurposeView'])
          }
        },
      }
    }
  },
  computed: {
    titleLabel() {
      if (this.isParentScreenForceNew) {
        return 'profile.label.crypto.force.news';
      }

      return 'profile.label.crypto';
    },

    cryptoPurposeDiverseFlag() {
      if (this.isParentScreenForceNew) {
        return 'profile.bo_investment_purpose.crypto_purpose_diverse_flg';
      }

      return 'trs.front.crypto.registration.label.diversified.investment';
    },

    errorMsgParam() {
      if (this.isParentScreenForceNew) {
        return 'profile.label.crypto.force.news';
      }

      return 'profile.label.crypto';
    }
  },
}
</script>

<style scoped>

</style>
